import { styled } from 'dripsy';
import React from 'react';
import { ModalComponentProp } from 'react-native-modalfy';
import { View } from 'react-native';

import { IS_WEB } from '@utils';
import { ModalStackParamsType } from '../../modals/types';
import { ModalView } from './components/ModalView';
import { BaseText } from '../common/BaseText';
import { IconTouchable } from '../common/IconTouchable';
import { Separator } from '../common/Separator';
import { Icon } from '../common/Icon';

const ModalViewContainer = styled(ModalView)({
  width: IS_WEB ? 343 : 289,
  p: '$6',
  alignItems: 'center',
});

const CrossIconContainer = styled(View)({
  position: 'absolute',
  zIndex: 1,
  elevation: 1,
  top: '$5',
  right: '$5',
});

const Title = styled(BaseText)({
  textAlign: 'center',
  variant: 'text.medium',
});

const Subtitle = styled(BaseText)({
  textAlign: 'center',
  variant: 'text.small',
  color: '$text400',
});

export interface IAlertModalParams {
  title: string;
  subtitle: string;
}

type ModalPropsType = ModalComponentProp<
  ModalStackParamsType,
  void,
  'AlertModal'
>;

export function AlertModal({ modal }: ModalPropsType) {
  function closeModalByCrossIcon() {
    modal.closeModal();
  }

  return (
    <ModalViewContainer>
      <CrossIconContainer>
        <IconTouchable
          onPress={closeModalByCrossIcon}
          name="close-light"
          size={24}
        />
      </CrossIconContainer>

      <Icon name="done-circule-light" color="$primary300" size={40} />

      <Separator size="$5" />
      <Title>{modal.params?.title}</Title>

      <Separator size="$2" />
      <Subtitle>{modal.params?.subtitle}</Subtitle>
    </ModalViewContainer>
  );
}
